export enum RateMessagePageStatus {
  Undefined = 'undefined',
  RateUseful = 'rateUseful',
  RateUseless = 'rateUseless',
  Error = 'error',
}
